<template>
  <a-drawer
    :title="title"
    :maskClosable="true"
    :width="700"
    placement="right"
    :closable="true"
    @close="handleCancel"
    :visible="visible"
    style="overflow: auto; padding-bottom: 53px"
  >
    <template slot="title">
      <div style="width: 100%">
        <span>{{ title }}</span>
        <span
          style="
            display: inline-block;
            width: calc(100% - 51px);
            padding-right: 10px;
            text-align: right;
          "
        >
          <a-button
            @click="toggleScreen"
            icon="appstore"
            style="height: 20px; width: 20px; border: 0px"
          ></a-button>
        </span>
      </div>
    </template>

    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item
          label="渠道名称"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            placeholder="请输入渠道名称"
            v-decorator="[
              'cname',
              { rules: [{ required: true, message: '请输入渠道名称!' }] },
            ]"
          />
        </a-form-item>

        <a-form-item label="场景" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-radio-group
            name="radioGroup"
            v-decorator="[
              'scene',
              {
                rules: [{ required: true, message: '请选择场景!' }],
                initialValue: 2,
              },
            ]"
          >
            <a-radio :value="2"> 二维码 </a-radio>
            <a-radio :value="1" disabled> 小程序 </a-radio>
          </a-radio-group>
        </a-form-item>

        <a-form-item label="类型" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <!-- 单人 -->
          <a-radio-group
            @change="ctypeChange"
            name="radioGroup"
            v-decorator="[
              'ctype',
              {
                rules: [{ required: true, message: '请选择类型!' }],
                initialValue: 0,
              },
            ]"
          >
            <a-radio :value="0"> 单人 </a-radio>
            <a-radio :value="1"> 多人 </a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item
          label="使用人员"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a @click="visibleshowuser = !visibleshowuser">点击选择使用人员</a>
          <a-drawer
            title="选择人员"
            width="320"
            :closable="false"
            :visible="visibleshowuser"
            @close="onClose"
          >
            <a-input-search
              v-model="popSearchValue"
              style="margin-bottom: 8px"
              placeholder="搜索"
              @change="onChangeUser"
            />
            <a-tree
              multiple
              treeCheckable="tree"
              checkable
              @expand="onExpand"
              :expandedKeys="expandedKey"
              :checkedKeys="checkedKeys"
              allowClear="true"
              @check="onCheck"
              :dropdownStyle="{ maxHeight: '200px', overflow: 'auto' }"
              :treeData="departTree"
              placeholder="请选择上级部门"
              v-decorator="[
                'userList',
                { rules: [{ required: true, message: '请选择人员!' }] },
              ]"
              :auto-expand-parent="autoExpandParent"
            >
            </a-tree>
            <!-- <a-tree-select
              show-search
             :tree-checkable="changeType==0?false:true"
              style="width: 100%"
              v-decorator="['userList', { rules: [{ required: true, message: '请选择人员!' }] }]"
              :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
              placeholder="请选择"
              :tree-data="departTree"
              :multiple="changeType==0?false:true"
              allow-clear
              tree-default-expand-all
              treeNodeFilterProp="title"
              @change="chooseUser"
            >
            </a-tree-select>  -->
          </a-drawer>
          <div>
            <a-tag
              v-for="(item, index) in tagList"
              :key="index"
              closable
              @close.prevent="closeUserTag(index)"
            >
              {{ item.title }}
            </a-tag>
          </div>
        </a-form-item>
        <a-form-item
          label="是否需要验证"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-radio-group
            name="radioGroup"
            v-decorator="[
              'needVerify',
              {
                rules: [{ required: true, message: '是否需要验证!' }],
                initialValue: '0',
              },
            ]"
          >
            <a-radio value="0"> 否 </a-radio>
            <a-radio value="1"> 是 </a-radio>
          </a-radio-group>
          <!-- 否 -->
        </a-form-item>
        <a-form-item
          label="添加标签"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a @click="visibleshow = !visibleshow">点击选择渠道标签</a>
          <a-drawer
            title="选择标签"
            width="320"
            :closable="false"
            :visible="visibleshow"
            @close="onCloseTag"
          >
            <a-tree
              multiple
              treeCheckable="tree"
              checkable
              :expandedKeys="channelExpandedKey"
              :checkedKeys="channelCheckedKeys"
              :tree-data="departTree1"
              @expand="onExpand1"
              @check="onCheck1"
              allowClear="true"
              v-decorator="['channelList']"
              :replace-fields="{
                children: 'tag',
                title: 'name',
                key: 'id',
              }"
            />
          </a-drawer>
          <div>
            <a-tag
              v-for="(item, index) in form.getFieldValue('channelList')"
              :key="index"
              closable
              @close.prevent="closeUserTag1(index)"
            >
              {{ item.title }}
            </a-tag>
          </div>
        </a-form-item>
        <a-form-item label="备注" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-textarea
            placeholder="请输入备注信息"
            :rows="4"
            v-decorator="['remark']"
          />
        </a-form-item>
        <a-form-item
          v-if="false"
          label="二维码"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <img src="../../../assets/chat.png" alt="" />
        </a-form-item>

        <a-form-item
          label="渠道欢迎语"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a @click="addWelcome">点击选择渠道欢迎语</a>

          <div v-if="welcomeDetail.textContent">
            <a-tag closable @close.prevent="closeTag">
              {{ welcomeDetail.textContent }}
            </a-tag>
          </div>
        </a-form-item>
      </a-form>
    </a-spin>

    <material-component
      ref="materialForm"
      @ok="modalFormOk"
      @selectWelcome="_selectWelcome"
    ></material-component>

    <div class="drawer-bootom-button" v-show="!disableSubmit">
      <a-popconfirm
        title="确定放弃编辑？"
        @confirm="handleCancel"
        okText="确定"
        cancelText="取消"
      >
        <a-button style="margin-right: 0.8rem">取消</a-button>
      </a-popconfirm>
      <a-button @click="handleSubmit" type="primary" :loading="confirmLoading"
        >提交</a-button
      >
    </div>
  </a-drawer>
</template>

<script>
import pick from 'lodash.pick';
import { loop } from '@/utils/common';

import moment from 'moment';
import Vue from 'vue';
// 引入搜索部门弹出框的组件
import departWindow from '../../system/modules/DepartWindow';
import JSelectPosition from '@/components/jeecgbiz/JSelectPosition';
import { ACCESS_TOKEN } from '@/store/mutation-types';
import { getAction, postAction, postTag } from '@/api/manage';
import { disabledAuthFilter } from '@/utils/authFilter';
import JImageUpload from '../../../components/jeecg/JImageUpload';
import { getCusAll } from '@/api/api';
import HttpTraceVue from '../../modules/monitor/HttpTrace.vue';
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import materialComponent from '../material/materialComponent';

const getParentKey = (key, tree) => {
  let parentKey;
  for (let i = 0; i < tree.length; i++) {
    const node = tree[i];
    if (node.children) {
      if (node.children.some((item) => item.key === key)) {
        parentKey = node.key;
      } else if (getParentKey(key, node.children)) {
        parentKey = getParentKey(key, node.children);
      }
    }
  }
  return parentKey;
};

export default {
  name: 'ChannelModal',
  components: {
    JImageUpload,
    departWindow,
    JSelectPosition,
    materialComponent,
  },
  mixins: [JeecgListMixin],
  data() {
    return {
      touser: '',
      changeType: 0,
      chooseValue: '',
      dataList: [],
      searchValue: '',
      autoExpandParent: true,
      visibleshowuser: false,
      visibleshow: false,
      departTree: [],
      departTree1: [],

      checkedKeys: [], // 存储选中的id
      expandedKey: [], // 展开的节点

      channelList: [],
      channelCheckedKeys: [], // 存储选中的id
      channelExpandedKey: [], // 展开的节点

      modalWidth: 800,
      modaltoggleFlag: true,
      disableSubmit: false,
      title: '操作',
      visible: false,
      model: {},
      labelCol: {
        xs: {
          span: 24,
        },
        sm: {
          span: 5,
        },
      },
      wrapperCol: {
        xs: {
          span: 24,
        },
        sm: {
          span: 16,
        },
      },
      confirmLoading: false,
      headers: {},
      form: this.$form.createForm(this),
      url: {
        // tagmanage  企业标签
        tagData: process.env.VUE_APP_CMS_WECHATWORK + '/wechatwork/tag/data',
        add: 'wechatwork-users-biz/wechatwork/channel/add',
        edit: 'wechatwork-users-biz/wechatwork/channel/update',
        detail: 'wechatwork-users-biz/wechatwork/channel/detail',
        fileUpload: 'wechatwork-groupchat-biz/wechatwork/wechatMsg/upMaterial',
        judgment:
          process.env.VUE_APP_CMS_WECHATUSERSBIZ +
          '/wechatwork/channel/judgeIsExistsViolationMember',
      },
      welcomeDetail: {},
      departTreeOriginal: [],
      userselectedList: [],
      endselect: [],
      tagList: [],
      checkedKeys2: [],
      showTree: [],
      pdlist: [],
      allcheckedlist: [],
      popSearchValue: undefined,
      treeLoading: false,
      tempData: [],
      userTamp: [],
    };
  },

  created() {
    const token = Vue.ls.get(ACCESS_TOKEN);
    this.headers = {
      'X-Access-Token': token,
    };
    this.initData();
    this.pdlist = this.showTree;
  },
  computed: {
    uploadAction: function () {
      return this.url.fileUpload;
    },
  },
  watch: {
    tempData() {
      this.deepDone5(this.tempData[0].children);
    },
  },
  // inject: ['reload'],
  methods: {
    loadData() {
      return false;
    },
    addWelcome() {
      // console.log(this.welcomeDetail);
      this.$refs.materialForm.add(this.welcomeDetail, 'channel');
    },
    _selectWelcome(p, p1) {
      // console.log(p, p1)
      this.welcomeDetail = p;
      this.welcomeDetail.welcomeId = p1.welcomeId;
      this.model = {
        ...this.model,
        ...p1,
      };
    },
    closeTag() {
      this.welcomeDetail = {};
      this.$refs.materialForm.deleteWelcome(1);
      this.$refs.materialForm.handleSubmit(1);
    },
    generateList(data) {
      for (let i = 0; i < data.length; i++) {
        const node = data[i];
        const key = node.key;
        this.dataList.push({
          key,
          title: node.title,
        });
        if (node.children) {
          this.generateList(node.children);
        }
      }
    },
    chooseUser(value, label, extra) {
      let arr = [value];
      if (typeof value == 'string') {
        this.popSearchValue = arr;
        this.userTamp = [
          {
            id: value.split('_')[0],
            name: label[0],
          },
        ];
      } else {
        this.popSearchValue = value;

        label.forEach((item, index) => {
          let obj = {
            id: value[index].split('_')[0],
            name: item,
          };
          this.userTamp.push(obj);
        });
      }

      this.form.setFieldsValue({ userList: this.popSearchValue });

      let labList = label.map((item) => {
        return (item = { title: item });
      });
      this.tagList = labList;

      if (this.changeType == 0) {
        this.touser = value.split('_')[0]; //value.substring(0,value.lastIndexOf('_'))
      } else {
        let newValue = [];
        value.map((item) => {
          newValue.push(item.split('_')[0]);
        });
        this.touser = newValue.join(',');
      }
    },
    onChangeUser(e) {
      const value = this.popSearchValue;
      const expandedKey = this.dataList;
      this.userselectedList = this.form.getFieldValue('userList');
      this.checkedKeys2 = this.checkedKeys;
      if (!value) {
        this.departTree = this.departTreeOriginal;
        this.pdlist = this.showTree;
      } else {
        this.departTree = [];
        this.pdlist = [];
        this.$nextTick(() => {
          this.deepDone(this.departTreeOriginal, value);
          this.departTree.forEach((item) => {
            this.pdlist.push(item);
          });
        });
      }
    },
    deepDone(arr, value) {
      arr.forEach((item) => {
        if (item.title.indexOf(value) > -1) {
          this.departTree.push(item);
        } else {
          if (item.children && item.children.length > 0) {
            this.deepDone(item.children, value);
          }
        }
      });

      //  console.log('this.departTree******',this.departTree)
    },
    deepDone3(arr) {
      arr.forEach((item) => {
        if (!item.children || item.children.length === 0) {
          this.showTree.push(item);
        } else {
          this.deepDone3(item.children);
        }
      });
    },
    deepDone2(arr, value) {
      arr.forEach((item) => {
        if (!item.children || item.children.length === 0) {
          if (this.pdlist.includes(item)) {
            if (
              item.key == value ||
              (Array.isArray(value) && value.indexOf(item.key) > -1)
            ) {
              item.checked = true;
            } else {
              item.checked = false;
            }
          }

          let index = this.allcheckedlist.findIndex(
            (e) => e.title == item.title
          );
          if (item.checked && index < 0) {
            // console.log("youle", item);
            this.allcheckedlist.push(item);
          }
        } else {
          this.deepDone2(item.children, value);
        }
      });
    },
    deepDone4(arr, value) {
      arr.forEach((item) => {
        if (!item.children || item.children.length === 0) {
          if (this.pdlist.includes(item)) {
            if (item.key == value) {
              item.checked = false;
            }
          }
        } else {
          this.deepDone4(item.children, value);
        }
      });
    },
    deepDone5(arr) {
      arr.forEach((item) => {
        if (!item.children || item.children.length === 0) {
          item.checked = false;
        } else {
          this.deepDone5(item.children);
        }
      });
    },
    deepDone6(arr, value, newarr) {
      arr.forEach((item) => {
        if (!item.children || item.children.length === 0) {
          if (item.key == value) {
            newarr.push(item.title);
          }
        } else {
          this.deepDone6(item.children, value, newarr);
        }
      });
    },
    add() {
      // this.closeTag()
      this.edit({});
    },
    edit(record) {
      // console.log(record,'-------')
      if (this.treeLoading) {
        this.$message.info('数据加载中');
        return;
      }
      if (this.departTreeOriginal[0]) {
        this.deepDone5(this.departTreeOriginal[0].children);
      }
      this.tagList = [];
      this.checkedKeys = [];
      this.channelCheckedKeys = [];
      let that = this;
      that.form.resetFields();

      if (record.id) {
        getAction(that.url.detail, {
          id: record.id,
        }).then((res) => {
          if (res.success) {
            that.$set(that, 'model', res.result);
            that.$emit('ok');
            that.welcomeDetail = res.result;
            that.model.channelId = res.result.id;
            that.model.relevanceId = res.result.relevanceId;
            that.tagList = that.model.users.map((e) => {
              return {
                key: e.userid,
                title: e.name,
              };
            });
            console.log('this.tagList*****', that.tagList);
            let checkedchannelList = [];
            let arrlisttwo = [];
            if (res.result.tagGroups) {
              res.result.tagGroups.forEach((e) => {
                checkedchannelList.push(e.tagNodes);
              });
            }
            if (checkedchannelList.length > 0) {
              checkedchannelList.forEach((e) => {
                e.forEach((item) => {
                  arrlisttwo.push(item);
                });
              });
            }
            if (arrlisttwo.length > 0) {
              that.model.channelList = arrlisttwo.map((item) => {
                return {
                  key: item.id,
                  value: item.id,
                  title: item.name,
                  name: item.name,
                  id: item.id,
                  groupId: item.groupId,
                  sort: item.sort,
                  deleted: item.deleted,
                  createTime: item.createTime,
                  channelRelevanceTagId: item.channelRelevanceTagId,
                };
              });
            }
            that.channelCheckedKeys = that.model.channelList
              ? that.model.channelList.map((e) => e.key)
              : [];
            that.channelExpandedKey = res.result.tagGroups
              ? res.result.tagGroups.map((e) => e.id)
              : [];
            // console.log(this.channelCheckedKeys);
            that.model.welcomeType = that.model.linkUrl ? 2 : 1;
            that.model.ctype = parseInt(that.model.ctype);
            that.changeType = parseInt(that.model.ctype);
            that.chooseValue = parseInt(that.model.ctype);
            that.model.scene = parseInt(that.model.scene);
            that.popSearchValue = undefined;
            // this.tagList.map(item=>{

            // })
            that.initForm();
          }
        });
      } else {
        that.model = Object.assign(
          {
            ctype: 0,
            scene: 2,
            welcomeType: 1,
          },
          record
        );
        this.initForm();
      }
    },
    initForm() {
      this.visible = true;
      this.$nextTick(() => {
        setTimeout(() => {
          this.form.setFieldsValue(
            pick(
              this.model,
              'cname',
              'scene',
              'needVerify',
              'channelList',
              'welcomeType',
              'imagePicUrl',
              'ctype',
              'remark'
            )
          );
        });
        this.form.setFieldsValue({
          userList: this.tagList,
        });
        this.checkedKeys = [...this.tagList.map((e) => e.key)];
        this.checkedKeys = [...new Set(this.checkedKeys)];
        // console.log(this.tagList, this.checkedKeys, '00000000000');
      });
    },
    closeUserTag(i) {
      // this.popSearchValue.splice(i,1)
      // debugger
      this.checkedKeys.splice(i, 1);
      // this.tagList[i].checked=false
      this.deepDone4(this.departTreeOriginal[0].children, this.tagList[i].key);
      // console.log(this.tagList[i]);
      this.tagList.splice(i, 1);
      // console.log(this.form.getFieldValue('userList'));
      // this.form.getFieldValue('userList').splice(i, 1)
      this.form.setFieldsValue({
        userList: this.form.getFieldValue('userList'),
      });
      // console.log(this.form.getFieldValue('userList'),this.tagList);

      // console.log(this.form.getFieldValue('userList'), this.checkedKeys,this.tagList)
    },
    closeUserTag1(i) {
      this.channelCheckedKeys.splice(i, 1);
      this.form.getFieldValue('channelList').splice(i, 1);
      this.form.setFieldsValue({
        channelList: this.form.getFieldValue('channelList'),
      });
    },
    ctypeChange(e) {
      this.form.setFieldsValue({
        userList: null,
      });
      console.log(e.target.value);
      this.checkedKeys = [];
      this.tagList = [];
      this.changeType = e.target.value;
      // this.chooseValue =e.target.value
      // if(e.target.value == 1 ){
      // this.tagList = []

      // }
      // console.log(e.target.value);
      console.log(this.departTree, '>>>');
      if (e.target.value == 1 && this.departTree[0]) {
        this.departTree[0].disableCheckbox = false;
        this.departTree[0].scopedSlots = {
          title: 'title',
        };
        this.departTree[0].children.forEach((item) => {
          item.disableCheckbox = false;
          item.scopedSlots = {
            title: 'title',
          };
          if (item.children != null) {
            if (item.children.length > 0) {
              item.children.forEach((el) => {
                el.disableCheckbox = false;
                el.scopedSlots = {
                  title: 'title',
                };
              });
            }
          }
        });
        // console.log(this.departTree)
      } else {
        this.initData();
      }
    },
    // 选择部门时作用的API
    onCheck(checkedKeys, info) {
      debugger;
      if (checkedKeys.length == 0) {
        this.checkedKeys = [];
      }

      let userList = [];
      // this.checkedKeys = checkedKeys.checked
      let checkedNodes = info.checkedNodes;
      for (let i = 0; i < checkedNodes.length; i++) {
        let de = checkedNodes[i].data.props;
        let depart = {
          key: de.value,
          value: de.id,
          title: de.title,
          parentName: de.dataRef.parentid,
        };
        if (!de.dataRef.children || de.dataRef.children.length === 0) {
          userList.push(depart);
        }
      }
      if (this.form.getFieldValue('ctype') == '0') {
        if (userList.length > 1) {
          userList = [userList[userList.length - 1]];
        }
        // let checkedList = checkedKeys
        if (checkedKeys.length >= 1) {
          this.checkedKeys = [checkedKeys[checkedKeys.length - 1]];
        }
        this.tagList = [...userList];
        this.form.setFieldsValue({
          userList,
        });
      }
      if (this.form.getFieldValue('ctype') == '1') {
        this.deepDone2(this.departTreeOriginal[0].children, checkedKeys);
        this.tagList = this.allcheckedlist.filter((e) => e.checked == true);

        // console.log(this.tagList);
        this.checkedKeys = [...this.tagList.map((e) => e.key)];
        this.checkedKeys = [...new Set(this.checkedKeys)];

        this.form.setFieldsValue({
          userList: this.tagList,
        });
        // let oldselected=[];
        // for (let index = 0; index < this.userselectedList.length; index++) {
        //   oldselected.push(this.userselectedList[index].key);
        // }
        // this.checkedKeys = [...checkedKeys,...oldselected]
        // this.checkedKeys=Array.from(new Set(this.checkedKeys))
        // this.tagList=[...this.tagList,...this.userselectedList]
        // this.tagList=Array.from(new Set(this.tagList))
        // this.checkedKeys =[...userList.map(e=>e.key)]
        // console.log(this.tagList, this.checkedKeys, this.pdlist, '88888');
      }
      // this.checkedKeys = checkedKeys
      // console.log('onCheck', checkedKeys, info)
    },
    onExpand(expandedKeys) {
      this.expandedKey = expandedKeys;
      this.autoExpandParent = false;
    },
    onCheck1(checkedKeys, info) {
      // console.log(checkedKeys, info);
      let channelList = [];
      // this.channelCheckedKeys = checkedKeys.checked
      let checkedNodes = info.checkedNodes;
      // channelList = checkedNodes
      for (let i = 0; i < checkedNodes.length; i++) {
        let de = checkedNodes[i].data.props;
        // let depart = {
        //   key: '',
        //   value: '',
        //   title: '',
        //   parentName: ''
        // }
        // depart.key = de.value
        // depart.value = de.id
        // depart.title = de.title
        // depart.parentName = de.dataRef.parentid

        // if (de.tag || de.tag.length === 0) {
        //   channelList.push(de)
        // }
        channelList.push(de);
      }
      // console.log(channelList, 55555);
      this.form.setFieldsValue({
        channelList,
      });
      this.channelCheckedKeys = checkedKeys;
      // console.log('onCheck', checkedKeys, info)
    },
    onExpand1(expandedKeys) {
      this.channelExpandedKey = expandedKeys;
      // console.log('onExpand', expandedKeys)
    },
    initData() {
      // this.treeLoading=true
      getCusAll().then((res) => {
        // console.log(res, '获取树结构');
        if (res.success) {
          this.treeLoading = false;
          this.departTree = res.result; //loop(res.result)
          this.tempData = this.departTreeOriginal = [...res.result];
          this.deepDone3(this.departTree);
          if (this.departTree && this.departTree.length > 0) {
            let treekey = [];
            let arr = res.result;
            if (arr && arr.length > 0) {
              arr.forEach((item) => {
                treekey.push(item.key);
              });
              this.expandedKey = treekey;
            }
          }
          this.generateList(res.result);
        }
      });
      getAction(this.url.tagData, {
        pageNo: 1,
        pageSize: 99999999,
        tagType: 2,
        type: 2,
      }).then((res) => {
        if (res.code == 0) {
          // this.departTree1 = res.result.list
          this.departTree1 = res.result.records;
          this.departTree1.forEach((item) => {
            if (item.tag.length > 0) {
              item.disabled = true;
              //   item.children=item.tag
              //   item.children.forEach(e=>{
              //     e.title=e.name
              //   })
              //   console.log(item,'you');
            }
          });
          // console.log(this.departTree1, '00000000000');
          if (this.channelExpandedKey && this.channelExpandedKey.length > 0) {
            let treekey = [];
            let arr = res.result.records;
            if (arr && arr.length > 0) {
              arr.forEach((item) => {
                treekey.push(item.id);
              });
              this.channelExpandedKey = treekey;
            }
          }
        }
      });
    },
    onCloseTag() {
      this.visibleshow = false;
    },
    onClose() {
      this.visibleshowuser = false;
      // this.onChangeUser();
    },
    isDisabledAuth(code) {
      return disabledAuthFilter(code);
    },
    // 窗口最大化切换
    toggleScreen() {
      if (this.modaltoggleFlag) {
        this.modalWidth = window.innerWidth;
      } else {
        this.modalWidth = 800;
      }
      this.modaltoggleFlag = !this.modaltoggleFlag;
    },
    close() {
      this.$emit('close');
      this.visible = false;
    },
    moment,
    handleSubmit() {
      // 触发表单验证
      this.form.validateFields((err, values) => {
        if (!err) {
          console.log(values);
          // this.confirmLoading = !!HttpTraceVue
          let url = '';
          if (!this.model.id) {
            url = this.url.add;
          } else {
            url = this.url.edit;
          }
          console.log('values.userList********', values.userList);
          let formData = Object.assign(this.model, values, {
            users: values.userList
              ? values.userList.map((e) => {
                  return {
                    id: e.key,
                    name: e.title,
                  };
                })
              : [],
            userIds: values.userList
              ? values.userList.map((e) => {
                  return e.key;
                })
              : [],
            tagIds: values.channelList || [],
            // channelRelevanceTagId: values.channelList ? values.channelList[0].id : ''
          });
          console.log('formData********', formData);

          // if(formData.userIds)
          formData.tags = formData.tags ? formData.tags : [];
          // let userArr=values.userList.map(e =>e.key);
          // let userString=this.touser
          getAction(this.url.judgment, {
            userIds: formData.userIds.join(','),
          }).then((res) => {
            // (res.success && !res.result)
            let result = res.result ? res.result : [];
            if (res.success && result.length == 0) {
              postTag(url, formData).then((res) => {
                if (res.success) {
                  this.$message.success(res.message);
                  this.$emit('ok');
                  this.close();
                  this.confirmLoading = false;
                } else {
                  this.close();
                  this.confirmLoading = false;
                  this.$message.error(res.message);
                }
              });
            } else if (res.result && res.result.length > 0) {
              let arr = [];
              res.result.forEach((e) => {
                this.deepDone6(this.departTreeOriginal[0].children, e, arr);
              });
              console.log(arr);
              this.$message.error(
                '选择的用户' + arr.join(',') + '没有外部联系人权限或者未激活'
              );
              this.confirmLoading = false;
            } else if (!res.success) {
              this.confirmLoading = false;
              this.$message.error(res.message);
            }
          });
        }
      });
    },
    handleCancel() {
      this.close();
    },
  },
};
</script>

<style scoped>
.avatar-uploader > .ant-upload {
  width: 104px;
  height: 104px;
}

.ant-upload-select-picture-card i {
  font-size: 49px;
  color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}

.ant-table-tbody .ant-table-row td {
  padding-top: 10px;
  padding-bottom: 10px;
}
.ant-select-tree-dropdown .ant-select-dropdown-search {
  display: none;
}
.drawer-bootom-button {
  position: absolute;
  bottom: -8px;
  width: 100%;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  left: 0;
  background: #fff;
  border-radius: 0 0 2px 2px;
}
</style>
